import React from 'react';
import {
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import BusinessEmailAddressInput from '../form-inputs/business-email-address-input/BusinessEmailAddressInput';
import BusinessPhoneNumberInput from '../form-inputs/bussiness-phone-number-input/BusinessPhoneNumberInput';
import AccountCircleIcon from '../../../static/assets/svg/account_circle.svg';
import BrushIcon from '../../../static/assets/svg/brush.svg';

import CircularProgress from '@mui/material/CircularProgress';
import { useEmergencyContactCardForm } from './useEmergencyContactCardForm';
import styles from './EmergencyContactCard.module.scss';
import ConfirmModal from '../confirm-modal/ConfirmModal';
import Tooltip from '@mui/material/Tooltip';
// import { SocialLink } from '../social-media-form/SocialMediaForm';
import { Employee } from '../../models/employee.model';

type EmergencyContactCardProps = {
  simplified?: boolean;
  employee: Partial<Employee>;
};

export default function EmergencyContactCard({ simplified, employee }: EmergencyContactCardProps) {
  const { t } = useTranslation();
  const isLoading = false;
  const {
    formData,
    handleChange,
    saveChanges,
    isEdited,
    toggleEditing,
    formRef,
    showModal,
    confirmExit,
  } = useEmergencyContactCardForm(employee);

  const disabledStyles = {
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'black', // Change text color
      WebkitTextFillColor: 'black', // Override browser autofill styles
    },
    '& .MuiOutlinedInput-root.Mui-disabled': {
      backgroundColor: '#f0f0f0', // Change background
      borderColor: 'red', // Change border color
    },
  };

  const relationshipOptions = ['Friend', 'Guardian', 'Parent', 'Partner', 'Sibling'];

  return (
    <Grid container className='inputs-editable'>
      <Grid item xs={12}>
        <Card className={`${styles.card} ${isEdited ? styles.card_border : ''}`} ref={formRef}>
          <CardContent className={isLoading ? styles.card_content_min_height : ''}>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <>
                <Grid container alignItems='center' flexWrap='nowrap' p={1}>
                  <Grid item xs={11} container alignItems='center' gap={1}>
                    <Grid sx={{ marginBottom: '0.2rem' }} item>
                      <AccountCircleIcon />
                    </Grid>
                    <Grid item>
                      <Typography variant='h6'>Emergency Contact</Typography>{' '}
                      {/* TODO : Add translation, for some reason didn't wanna work will look later */}
                    </Grid>
                  </Grid>
                  <Grid item xs={1} container justifyContent='flex-end'>
                    {!isEdited ? (
                      <Tooltip className='flex-shrink-0' title={t('buttons.edit')} placement='top'>
                        <IconButton onClick={toggleEditing}>
                          <BrushIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Button
                        type='submit'
                        className='btn-default btn-action-basic'
                        role='button'
                        disabled={!isEdited}
                        variant='contained'
                        size='large'
                        onClick={saveChanges}
                      >
                        {t('buttons.save')}
                      </Button>
                    )}
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          value={formData.full_name}
                          label='Full name' // TODO : Add translation
                          onChange={(e) => {
                            handleChange('full_name')(e.target.value);
                          }}
                          disabled={!isEdited}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <BusinessEmailAddressInput
                          value={formData.email_address}
                          onChange={handleChange('email_address')}
                          disabled={!isEdited}
                          label={t('labels.emailAddress')}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <BusinessPhoneNumberInput
                          value={formData.phone_number}
                          onChange={handleChange('phone_number')}
                          disabled={!isEdited}
                          label={t('labels.phoneNumber')}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <Select
                          fullWidth
                          value={formData.relationship || ''}
                          onChange={(e) => {
                            e.stopPropagation();
                            handleChange('relationship')(e.target.value);
                          }}
                          disabled={!isEdited}
                          displayEmpty
                          inputProps={{ 'aria-label': t('labels.relationship') }}
                        >
                          <MenuItem value='' disabled>
                            Select Relationship
                          </MenuItem>
                          {relationshipOptions.map((option) => (
                            <MenuItem
                              key={option}
                              value={option}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                {
                  <Grid container className={styles.container_margin_top} alignItems='center'>
                    <Grid item>
                      {/* <Tooltip title={t('businessProfile.addSocials')} placement='top'>
                        <IconButton
                          onClick={toogleEditingSocialModal}
                          className={styles.add_social_button}
                        >
                          <AddCircleOutlineIcon />
                        </IconButton>
                      </Tooltip> */}
                    </Grid>
                  </Grid>
                }
              </>
            )}
          </CardContent>
        </Card>
      </Grid>
      <ConfirmModal open={showModal} onClose={saveChanges} onConfirm={confirmExit} />
      {/* <AddSocialsModal
        open={showAddSocialModal}
        onClose={saveChangesSocialForm}
        onConfirm={toogleEditingSocialModal}
      /> */}
    </Grid>
  );
}
